import { FormattedMessage } from 'react-intl';

import { AccountCreation } from '@/components/signup/account-creation/account-creation';
import { TwcOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { ProductKey } from '@/components/signup/utils/products';
import { useLocation } from '@/utils/location-provider';

import { GetStartedText } from '../../components/get-started-heading';
import { Headings } from '../../components/headings';

export const LoggedOut = () => {
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const primaryCollectionProduct = params.get('primaryCollectionProduct');
	let heading: React.ReactNode = (
		<Headings
			main={<GetStartedText productName="Teamwork Collection" />}
			sub={
				<FormattedMessage
					id="signup.teamworkCollection.subHeading"
					defaultMessage="It's free for up to 10 users - no credit card needed."
				/>
			}
		/>
	);

	if (primaryCollectionProduct === ProductKey.ROVO) {
		heading = (
			<Headings
				main={
					<FormattedMessage
						id="signup.teamworkCollection.rovoHeading"
						defaultMessage="Get Teamwork Collection to start using Rovo"
					/>
				}
				sub={
					<FormattedMessage
						id="signup.teamworkCollection.rovoSubHeading"
						defaultMessage="Free for up to ten users. Start using Rovo in 20 minutes or less after sign-up."
					/>
				}
			/>
		);
	}

	return (
		<TwcOverlayTemplate size="sm">
			{heading}
			<AccountCreation />
		</TwcOverlayTemplate>
	);
};
